
    import '/vercel/path0/docs/guide/page-tab.md?watch=parent';
    export const toc = [{"id":"页面-tab","depth":1,"title":"页面 Tab"}];
export const frontmatter = {"title":"页面 Tab","toc":"menu","filename":"docs/guide/page-tab.md","lastUpdated":1717482106000,"group":"进阶","order":1,"description":"为了便于开发者更优雅地组织复杂文档，比如将 API、示例、设计规范等内容组合呈现，dumi 提供了开箱即用的约定式页面 Tab 特性，以该篇文档为例："};